import React, {Component} from 'react';
import {Button, ControlLabel, FormControl, FormGroup, Modal} from 'react-bootstrap';
import ErrorMessageContainer from './ErrorMessageContainer';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import axios from 'axios';

require('moment/locale/el');

const DeliverableAttachmentLink = ({link}) => {
    if (!link) {
        return null;
    }

    return (
        <a target="_blank" href={link}>
            <i className="fa fa-cloud-download"></i> {window.__js_contracts.download_current_file}
        </a>
    );
};

export default class EditDeliverableModal extends Component {
    constructor() {
        super();

        this.state = {
            validationErrors: [],
            submitDisabled: false,
            deliverable_id: 0,
            title: "",
            deadline: moment(),
            attachment_url: null,
        };

        this.attachmentInputRef = React.createRef();

        this.handleValueChange = this.handleValueChange.bind(this);
        this.submit = this.submit.bind(this);
        this.close = this.close.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.id !== 0) {
            const url = this.props.is_supplier
                ? `/my_contracts/${this.props.contractId}/deliverables/${nextProps.id}`
                : `/contracts/ajax/manage_contracts/${this.props.contractId}/edit_deliverable/${nextProps.id}`;

            this.setState({
                validationErrors: [],
                submitDisabled: true
            }, () => {
                axios
                    .get(url)
                    .then((response) => {
                        let deliverable = response.data;
                        let deadline = moment();

                        if (deliverable.deadline_formatted === null)
                            deadline = moment();
                        else if (deliverable.deadline_formatted === "")
                            deadline = "";
                        else
                            deadline = moment(deliverable.deadline_formatted, "DD/MM/YYYY");

                        this.setState({
                            validationErrors: [],
                            submitDisabled: false,
                            deliverable_id: deliverable.id,
                            title: deliverable.title,
                            deadline: deadline,
                            attachment_url: deliverable.attachment_url || null,
                        });
                    });
            });
        } else {
            this.setState({
                validationErrors: [],
                submitDisabled: false,
                deliverable_id: 0,
                title: "",
                deadline: moment(),
                attachment_url: null,
            });
        }
    }

    handleValueChange(key, value) {
        this.setState({[key]: value});
    }

    submit() {
        if (!this.state.submitDisabled) {
            this.setState({
                validationErrors: [],
                submitDisabled: true
            }, () => {
                const url = this.props.is_supplier
                    ? `/my_contracts/${this.props.contractId}/deliverables/${this.state.deliverable_id}`
                    : `/contracts/ajax/manage_contracts/${this.props.contractId}/edit_deliverable/${this.state.deliverable_id}`;

                const deadlineDate = this.state.deadline !== "" ? this.state.deadline.format("DD/MM/YYYY") : "";
                const file = this.attachmentInputRef.current.files[0];
                const formData = new FormData();

                formData.append('deadline', deadlineDate);
                formData.append('title', this.state.title);

                if (file) {
                    formData.append('attachment', file);
                }

                axios
                    .post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then((response) => {
                        this.setState({
                            submitDisabled: false
                        }, () => {
                            window.location = this.props.redirect_url;
                        });
                    })
                    .catch((failure) => {
                        this.setState({
                            validationErrors: failure.response.data,
                            submitDisabled: false
                        });
                    });
            });
        }
    }

    close() {
        this.props.closeCallback();
    }

    render() {
        return (
            <Modal show={this.props.showModal} onHide={this.close}>
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_contracts.edit_deliverable}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ErrorMessageContainer errors={this.state.validationErrors}/>

                    <FormGroup controlId="title">
                        <ControlLabel>{window.__js_contracts.title}*</ControlLabel>
                        <FormControl type="text"
                                     value={this.state.title}
                                     name="title"
                                     id="title"
                                     onChange={(e) => this.handleValueChange("title", e.target.value)}/>
                    </FormGroup>
                    <FormGroup controlId="deadline">
                        <ControlLabel>{window.__js_contracts.deliverable_date}*</ControlLabel>
                        <DatePicker className="form-control"
                                    name="deadline"
                                    id="deadline"
                                    selected={this.state.deadline}
                                    onChange={(selected_date) => this.handleValueChange("deadline", selected_date)}
                                    dateFormat="DD/MM/YYYY"
                                    locale="el"/>
                    </FormGroup>
                    <FormGroup controlId="attachment">
                        <ControlLabel>{window.__js_contracts.attached_file}</ControlLabel>
                        <input
                            type="file"
                            className="form-control"
                            name="attachment"
                            id="attachment"
                            ref={this.attachmentInputRef}
                        />
                        <DeliverableAttachmentLink link={this.state.attachment_url}/>
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.submit} bsStyle="primary"
                            disabled={this.state.submitDisabled}>{window.__js_general.save}</Button>
                    <Button onClick={this.close}>{window.__js_general.close}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}